import {
  PushNotificationSourceType,
  PushNotificationSourceTypeLabel,
  PushNotificationType,
} from 'constants/pushNotifications';

export const NOTIFICATION_TYPE_FILTER_OPTIONS = [
  { value: null, label: 'All' },
  { value: PushNotificationType.ERROR, label: 'Error' },
  { value: PushNotificationType.WARNING, label: 'Warning' },
  { value: PushNotificationType.INFO, label: 'Info' },
  { value: PushNotificationType.SUCCESS, label: 'Success' },
];

export const NOTIFICATION_SOURCE_FILTER_OPTIONS = [
  { value: null, label: 'All' },
  {
    value: PushNotificationSourceType.LOAN,
    label: PushNotificationSourceTypeLabel[PushNotificationSourceType.LOAN],
  },
  {
    value: PushNotificationSourceType.PIPELINE,
    label: PushNotificationSourceTypeLabel[PushNotificationSourceType.PIPELINE],
  },
  {
    value: PushNotificationSourceType.SYSTEM,
    label: PushNotificationSourceTypeLabel[PushNotificationSourceType.SYSTEM],
  },
  {
    value: PushNotificationSourceType.USER,
    label: PushNotificationSourceTypeLabel[PushNotificationSourceType.USER],
  },
];
